import { message } from 'ant-design-vue'
import { getContactsInfo } from '../../api/contacts'
import Cookies from 'js-cookie'
import { getUserid } from '@/api/auth'

const state = {
  userid: '',
  username: '',
  avatar: '',
  groups: [],
  isAdmin: false,
  userInfo: null,
  qywxUserid: '',
}
const getters = {
  userid: (state) => state.userid,
  username: (state) => state.username,
  avatar: (state) => state.avatar,
  groups: (state) => state.groups,
  isAdmin: (state) => state.isAdmin,
  userInfo: (state) => state.userInfo,
  qywxUserid: (state) => state.qywxUserid,
}
const mutations = {
  /**
   * 设置userid
   * @param state
   * @param userid
   */
  setUserId(state, userid) {
    state.userid = userid
  },
  /**
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username
  },
  /**
   * @description 设置头像
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setGroups(state, groups) {
    state.groups = groups
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
  },
  /**
   * 设置是否超级管理员
   * @param state
   * @param isAdmin
   */
  isAdmin(state, isAdmin) {
    state.isAdmin = isAdmin
  },
  setQywxUserid: (state, qywxUserid) => {
    state.qywxUserid = qywxUserid || ''
  },
}
const actions = {
  async getUserid() {
    const { data } = await getUserid()
    return data
  },
  async setUserId({ commit }, userid) {
    commit('setUserId', userid)
  },
  /**
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit, state }) {
    const { data } = await getContactsInfo({ id: state.userid })
    if (!data) {
      message.error(`验证失败，请重新登录...`)
      return false
    }
    // console.log(data)
    let { name, avatar, groups } = data
    if (name) {
      commit('setUsername', name)
      commit('setAvatar', avatar)
      commit('setGroups', groups || [])
      commit('setUserInfo', data)
      if (groups && groups.indexOf('1') !== -1) {
        commit('isAdmin', true)
      } else {
        commit('isAdmin', false)
      }
    } else {
      message.error('用户信息接口异常')
      return false
    }
  },
  /**
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    await dispatch('resetAll')
  },
  /**
   * @description 重置userid
   * @param {*} { commit, dispatch }
   */
  async resetAll({ dispatch }) {
    Cookies.remove('ukey', { path: '/', domain: '.ehafo.com' })
    Cookies.remove('userid', { path: '/', domain: '.ehafo.com' })
    localStorage.removeItem('loginRedirect')
    await dispatch('setUserId', '')
  },
  setQywxUserid({ commit }, qywxUserid) {
    commit('setQywxUserid', qywxUserid)
  },
}
export default { state, getters, mutations, actions }
